// extracted by mini-css-extract-plugin
export default {"links":"styles_links__scImu","notAvailable":"styles_notAvailable__HWZY7","link":"styles_link__MO1l2"};